import {
  Box,
  Container,
  VStack,
  useToast,
  Text,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import Input from "components/Input/Input";
import { useState, useRef } from "react";
import Recaptcha from "react-google-recaptcha";
//
// import { useForgotPasswordMutation } from "services/arbitraryApi";

import { useHistory, Link } from "react-router-dom";

import constant from "config/constant";
// import { toLower } from "lodash";
import { post } from "util/axiosLib";
import useAuth from "hooks/useAuth";

const ForgotPassword = () => {
  const toast = useToast();
  const history = useHistory();

  const recaptchaInstanceRef = useRef();
  const [loading, setLoading] = useState(false);

  // const [forgot, { isLoading, isSuccess, isError, error, data }] =
  //   useForgotPasswordMutation();

  // const getError = (error) => {
  //   function isObj(obj) {
  //     var type = typeof obj;
  //     return type === "function" || (type === "object" && !!obj);
  //   }
  //   const value = isObj(error) ? Object.values(error)[0] : error;
  //   return value ?? "An unexpected error occurred";
  // };

  const [email, setEmail] = useState("");
  const { token } = useAuth();
  const headers = {
    authorization: token,
    "Content-Type": "application/json",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("i got here");

    if (navigator.onLine === true) {
      setLoading(true);
      try {
        const captcha = await recaptchaInstanceRef.current?.executeAsync();
        //   const reqData = { code: pin, captcha };
        // const reqData = {
        //   email,
        //   humanKey: captcha,
        // };

        // console.log("REQUEST DATA", reqData);

        // forgot(reqData);
        const response = await post(
          `${process.env.REACT_APP_API_ENDPOINT}/auth/forgotPassword?humanKey=${captcha}`,
          { email, ...headers }
        );

        console.log(response, "NEW API");
        if (response.status === "success") {
          setLoading(false);

          console.log(response.data, "DATA HERE");
          toast({
            position: "bottom-right",
            title: "Success",
            description: response.data.message,
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          history.replace(`${constant.PAGES.RESET_CODE}?email=${email}`);
        }

        if (response.status === 202) {
          setLoading(false);

          console.log(response.data, "DATA HERE");

          toast({
            position: "bottom-right",
            title: "Success",
            description: response.data.message,
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          history.replace(`${constant.PAGES.RESET_CODE}?email=${email}`);
        }

        // toast({
        //   position: "bottom-right",
        //   title: "Oops!!",
        //   description: getError(error?.data?.error),
        //   status: "error",
        //   duration: 18000,
        //   isClosable: true,
        // });

        // if (toLower(error?.data?.error).includes("no phone number")) {
        //   history.push(`${constant.PAGES.PHONE_NUMBER}?email=${email}`);
        // }
      } catch (error) {
        setLoading(false);
        console.log(error, "error here");
        await recaptchaInstanceRef.current?.reset();
        toast({
          position: "bottom-right",
          title: "Oops!!",
          description: error.error,
          status: "error",
          duration: 18000,
          isClosable: true,
        });
      }
    } else {
      toast({
        position: "bottom-right",
        title: "Network Error!!",
        description: "Please check your network connection",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  // useEffect(() => {
  //   if (isSuccess && data) {
  //     console.log("PASSWORD RESET RESULT", data);
  //     recaptchaInstanceRef.current?.reset();

  //     //   dispatch(hydrateToken(data.token))
  //     toast({
  //       position: "bottom-right",
  //       title: "Success",
  //       description: "Please check your phone for reset code",
  //       status: "success",
  //       duration: 9000,
  //       isClosable: true,
  //     });

  //     history.replace(`${constant.PAGES.RESET_CODE}?email=${email}`);
  //   }

  //   if (isError && error) {
  //     console.log("PASSWORD RESET ERROR", error);
  //     recaptchaInstanceRef.current?.reset();
  //     toast({
  //       position: "bottom-right",
  //       title: "Oops!!",
  //       description: getError(error?.data?.error),
  //       status: "error",
  //       duration: 18000,
  //       isClosable: true,
  //     });

  //     if (toLower(error?.data?.error).includes("no phone number")) {
  //       history.push(`${constant.PAGES.PHONE_NUMBER}?email=${email}`);
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, [isSuccess, data, isError, error, history, toast]);

  // const isDisabled = () => isLoading;

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="lg">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Link to="/">
              <Box w={["100px", "initial"]} as={Logo} />
            </Link>

            <Text
              textAlign="center"
              fontSize={["32px", "3xl"]}
              mt="24px !important">
              Forgot Password
            </Text>
            <Text
              textAlign="center"
              fontSize={["sm", "md"]}
              color="#4e4b66"
              //   mt="24px !important"
            >
              Enter your email to reset password
            </Text>
          </VStack>

          <Box mt="50px">
            <form onSubmit={handleSubmit}>
              <VStack>
                <FormControl>
                  <FormLabel>Email</FormLabel>
                  <Input
                    isRequired
                    minW="100%"
                    type="email"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </FormControl>

                <Recaptcha
                  ref={recaptchaInstanceRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA}
                  size={"invisible"}
                />

                <Button
                  disabled={loading}
                  isLoading={loading}
                  minW="100%"
                  minH="56px"
                  fontWeight="normal"
                  mt="30px !important"
                  type="submit">
                  Reset
                </Button>
              </VStack>
            </form>
          </Box>
        </Box>
      </Container>
    </VStack>
  );
};

export default ForgotPassword;
